module.exports = __webpack_public_path__ + "static/img/vue-logo.7dfb4d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vue-logo.png
// module id = DlpH
// module chunks = 0